<template>
    <div
        class="add-container"
    >
        <!-- 每个 XXX 的视图，除了自定义的内容，其次就是一定包含一个 option-city 组件 -->
        <el-card
            v-for="(item,index) in itemList"
            :key="item._uuid_"
            class="add-item"
            shadow="hover"
        >
            <xx-form-item
                v-if="showCityList"
                label="适用城市"
            >
                <basic-plan-city-select
                    v-if="useBasicCity"
                    ref="optionCity"
                    class="city-select"
                    :value="item.cityIds"
                    :data="shared.allAreaCityList"
                    show-tags
                    :show-select-all="false"
                    :existed-ids="item.existedIds"
                    :public-ids="innerPublicCityIds"
                    :selected-ids="item.cityIds"
                    :uuid="item['_uuid_']"
                    :disabled="disabled"
                    :title="title"
                    :pre-sku-id="preSkuId"
                    :is-pb-city-disabled-ids="pbCityDisabledIds"
                    :guarantee-period-map="guaranteePeriodRuleMap"
                    :use-permission="true"
                    @update:selected:city="syncAllSelectIds"
                    @selected-ids-change="updateInnerPublic"
                />
                <option-city
                    v-else
                    ref="optionCity"
                    :all-city-list="allCityList"
                    :selected-ids="item.cityIds"
                    :public-ids="innerPublicCityIds"
                    :existed-ids="item.existedIds"
                    :uuid="item['_uuid_']"
                    :disabled="disabled"
                    :pre-sku-id="preSkuId"
                    :guarantee-period-rule-map="guaranteePeriodRuleMap"
                    @update:selected:city="syncAllSelectIds"
                    @selected-ids-change="updateInnerPublic"
                />
            </xx-form-item>
            <slot
                :item="item"
                :$index="index"
            ></slot>
            <!-- 如果是必填，且是第一项，则不展示删除按钮 -->
            <!-- TODO 放开删除
                 v-if="!(isRequired && index === 0)"  -->
            <el-button
                v-if="canDeleteCondition(item, index, itemList)"
                class="delete-btn"
                type="warning"
                size="mini"
                :disabled="disabled"
                @click="deleteItem(index)"
            >
                删除
            </el-button>
        </el-card>
        <el-button
            type="primary"
            size="small"
            :disabled="innerDisabled || haveNoPublicCityIds || addBtnDisabled || disabled"
            @click="addItem"
        >
            增加{{ title }}
        </el-button>
        <span
            v-show="haveNoPublicCityIds"
            style="color: #585D66"
        >
            (所有城市都已选择{{ title }}，如需新增请先取消一个城市)
        </span>
    </div>
</template>

<script>
import { getAliasUuid } from 'tools/utils';
import OptionCity from './optionCity';
import BasicPlanCitySelect from '../components/BasicPlanCitySelect';
import { shared } from '../shareState';
import { getBaseModel } from '../baseModel';

export default {
    name: 'AddContainer',
    components: {
        OptionCity,
        BasicPlanCitySelect,
    },
    props: {
        title: {
            type: String,
            required: true,
            default: () => {
                throw new Error('未提供 title');
            },
        },
        initItem: { // 返回一个 item 的结构，每个 item 一定有 cityIds，TODO: 解决 item 的 cityIds 更新问题
            type: Function,
            required: true,
            default: () => {
                throw new Error('未提供 initItem 方法，无法初始化');
            },
        },
        itemList: {
            type: Array,
            default: () => [],
        },
        showCityList: {
            type: Boolean,
            default: true,
        },
        // 是否至少保留一个item，“是”则第一个item没有delete按钮
        isRequired: {
            type: Boolean,
            default: true,
        },
        // 支持传入，比如配方单需要根据是否是【加工品】进行过滤，默认取全部可以上新的城市
        publicCityIds: {
            type: Array,
            default: () => [],
        },
        allCityList: {
            type: Array,
            default: () => [],
        },
        // 最大个数 默认10个
        maxSize: {
            type: Number,
            default: 10,
        },
        canDeleteCondition: {
            type: Function,
            default: (item, index) => index > 0,
        },
        addBtnDisabled: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        preSkuId: {
            type: String,
            default: '',
        },
        // 按城市分组的保质期规则映射
        guaranteePeriodRuleMap: {
            type: Object,
            default: () => ({}),
        },
        // 是否使用基盘城市选择器
        useBasicCity: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            innerPublicCityIds: this.publicCityIds,
            shared,
        };
    },
    computed: {
        innerDisabled() {
            if (this.itemList.length >= this.maxSize) return true;
            // TODO 暂时放开，后续优化逻辑
            // if (this.showCityList && this.innerPublicCityIds.length === 0) return true;
            return false;
        },
        initMaxPublicIds() {
            return [...this.publicCityIds] || [];
        },
        // 当没有可选择追加的城市，不能新增，且给出文案提示
        haveNoPublicCityIds() {
            return this.showCityList && !this.innerPublicCityIds.length;
        },
        // 计算需要禁用的 PB 城市列表（从 baseModel 中提取）
        pbCityDisabledIds() {
            if (!this.preSkuId) {
                return [];
            }
            try {
                const baseModel = getBaseModel();
                const citySkuManageSection = baseModel.models.citySkuManageSection || baseModel.data?.citySkuManageSection;
                const citySkuManageInfo = citySkuManageSection?.citySkuManageInfo || [];
                return citySkuManageInfo.map((item) => item.cityId);
            } catch (error) {
                console.error('获取 PB 城市列表失败:', error);
                return [];
            }
        },
    },
    watch: {
        itemList(newVal) {
            if (newVal) {
                this.itemList.forEach((item) => {
                    if (!item._uuid_) item._uuid_ = getAliasUuid();
                });
            }
            // 从第1步返回第2步时，itemList 常见“先空后异步回填”：
            // 如果此时依赖 $refs 计算，会因 $refs 为空把 innerPublicCityIds 误算成全集，导致已选城市可再次选择
            this.$nextTick(() => {
                this.updateInnerPublic();
            });
        },
        publicCityIds(newVal) {
            this.innerPublicCityIds = newVal;
            this.$nextTick(() => {
                this.updateInnerPublic();
            });
        },
    },
    created() {
        if (this.itemList.length) {
            this.itemList.forEach((item) => {
                item._uuid_ = getAliasUuid();
            });
        }
    },
    mounted() {
        // 等子组件optionCity创建后，更新一次可选城市
        // 这次调用形同虚设，因为同步执行到这里，子组件已选择的城市id获取不到。因为数据是异步获取。
        // 这里的设计并没有控制 组件得到异步数据之后 再开始渲染。所以无法通过同步的生命周期方式，在父组件mount的时候获取子组件内部的状态。
        // 所以改为通过子组件状态的变化，通知父组件进行更新公共可选城市...
        // 可能更新会调用多次，但是作为公共业务组件，内部的状态需要自己维护，形成闭环，而不是通过外部控制何时渲染。
        this.updateInnerPublic();
    },
    methods: {
        // 获取所有当前各个配方单已经选择的 cityIds，然后和总的上新中新增城市全集对比，求出差集
        updateInnerPublic() {
            // 以 itemList.cityIds 作为单一数据源，避免依赖 $refs（渲染时序/异步回填导致取不到已选值）
            const currentAllSelectedIds = (this.itemList || [])
                .map((item) => item.cityIds || [])
                .flat();
            this.innerPublicCityIds = window._.difference(this.initMaxPublicIds, currentAllSelectedIds);
        },
        syncAllSelectIds({ uuid, selectCityIds }) {
            this.updateInnerPublic();
            const target = this.itemList.find((item) => item._uuid_ === uuid);
            if (!target) return;
            target.cityIds = selectCityIds;
            this.updateInnerPublic();
            // 当没有公共可选城市，处理清空：判断所有item中hasEffectiveIds字段，如果为false，则清理
            this.$nextTick(() => {
                if (!this.innerPublicCityIds.length) {
                    (this.$refs.optionCity || []).filter((vm) => !vm.hasEffectiveIds).forEach((vm) => {
                        const idx = this.itemList.findIndex((item) => item._uuid_ === vm.uuid);
                        if (idx > -1) this.deleteItem(idx);
                    });
                }
            });
        },
        addItem() {
            // 新增前，重新计算 publicIds
            this.updateInnerPublic();
            // 公共可选城市为空之后，不能新增
            if (this.showCityList && !this.innerPublicCityIds.length) return;

            this.itemList.push(Object.assign(this.initItem(), { _uuid_: getAliasUuid() }));
            this.$emit('change', this.itemList);
        },

        deleteItem(index) {
            // 点击删除要触发 option-city 重新计算 publicIds
            this.itemList.splice(index, 1); // 疑问：减少了 itemList，但是 this.$refs.optionCity.length 却没有改变
            if (this.showCityList) {
                this.updateInnerPublic();
            }
            this.$emit('change', this.itemList);
        },
        updatePublicCityIds() {
        },
        getData() {
            return this.itemList;
        },
    },
};
</script>

<style scoped>
.add-item{
    margin-bottom: 15px;
    position: relative;
}
.delete-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
    min-width: 30px !important;
}
::v-deep basic-plan-city-select .mc-level-select-tag-wrapper .mtd-input__inner{
    max-width: 600px;
    min-height: 32px;
}
::v-deep .mc-level-select-tag-wrapper .mtd-input__inner{
    max-width: 600px;
    min-height: 32px;
}
</style>
